import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-background-50/95 backdrop-blur-sm border-b border-background-200/70' : 'bg-transparent'}`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="w-8 h-8 flex items-center justify-center">
              <i className="ri-book-open-line text-xl text-primary-500"></i>
            </span>
            <span className="text-lg font-bold text-foreground-900 font-heading">韩漫画网</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap transition-colors ${location.pathname === '/' ? 'text-primary-500' : 'text-foreground-700 hover:text-primary-500'}`}
            >
              首页
            </Link>
            {categories.filter(c => c.slug !== 'all').slice(0, 5).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium whitespace-nowrap transition-colors ${location.pathname === `/category/${cat.slug}` ? 'text-primary-500' : 'text-foreground-700 hover:text-primary-500'}`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors ${location.pathname === '/about' ? 'text-primary-500' : 'text-foreground-700 hover:text-primary-500'}`}
            >
              关于我们
            </Link>
          </div>

          <div className="flex items-center gap-3">
            <button className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-background-100 transition-colors cursor-pointer" aria-label="搜索">
              <i className="ri-search-line text-lg text-foreground-700"></i>
            </button>
            <button
              className="md:hidden w-8 h-8 flex items-center justify-center rounded-full hover:bg-background-100 transition-colors cursor-pointer"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="菜单"
            >
              <i className={`text-lg text-foreground-700 ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 shadow-lg">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link to="/" className="py-3 px-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors">首页</Link>
            {categories.filter(c => c.slug !== 'all').map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="py-3 px-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors"
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="py-3 px-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors">关于我们</Link>
          </div>
        </div>
      )}
    </header>
  );
}